/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query ContentTranslationReadQuery($type: CUSTOMER_TYPE!,$take: Int, $skip: Int, $filter: JSONObject) {
  ContentTranslationRead(type: $type,take: $take, skip: $skip, filter: $filter) {
    id,
    createdAt,
    updatedAt,
    strategy,
    suffix,
    prefix,
    omitWords,
    regex,
    type,
    status,
    message,
    CustomerAccount {
      displayName,
      id
      },
    VendorAccount {
      displayName,
      id
    }
    Mcc {
      mcc,
      countryName
    }
  }
}
`
